export default "__VITE_ASSET__82488b4a__"